'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stateReaders = require('./stateReaders');

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSelectedAddress = function getSelectedAddress(_getAddresses, _getSelectedAddressId) {
  return function (addressType) {
    var id = _getSelectedAddressId(addressType);
    if (!id) return null;

    return _getAddresses().find(function (a) {
      return a.id === id;
    });
  };
};

exports.default = function (props) {
  var _addressBook = (0, _stateReaders.makeAddressBook)(props);
  var _user = (0, _stateReaders.makeUser)(props);
  var _dispatch = props.dispatch;
  var _getAddresses = (0, _stateReaders.getAddresses)(_addressBook);

  return (0, _extends3.default)({}, props, {
    getAddresses: _getAddresses,
    isAddressBookAvailable: (0, _stateReaders.isAddressBookAvailable)(_user),
    fetchAddresses: (0, _actions.fetchAddresses)(_dispatch),
    updateAddress: (0, _actions.updateAddress)(_dispatch),
    createAddress: (0, _actions.createAddress)(_dispatch),
    deleteAddress: (0, _actions.deleteAddress)(_dispatch),
    setAddressSelected: (0, _actions.setAddressSelected)(_dispatch),
    getSelectedAddress: getSelectedAddress(_getAddresses, (0, _stateReaders.getSelectedAddressId)(_addressBook))
  });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/higherOrder/addressBook/behaviours.js
// module id = 2340
// module chunks = 0